export enum vlanConfigLabel {
  UNTAGGED = 'Untagged',
  SINGLE_VLAN = 'Single VLAN',
  Q_IN_Q = 'Q-in-Q'
}

export enum vlanConfigValue {
  UNTAGGED = 'untagged',
  SINGLE_VLAN = 'tagged',
  Q_IN_Q = 'q_in_q'
}

export const VLAN_CONFIG_TYPE = [
  { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
  { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
  { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
];

export enum ETHER_TYPE_LABEL {
  ETHER_8100 = '8100',
  ETHER_88a8 = '88a8',
  ETHER_9100 = '9100'
}

export const ETHER_TYPE = [
  { name: '8100', value: ETHER_TYPE_LABEL.ETHER_8100 },
  { name: '88a8', value: ETHER_TYPE_LABEL.ETHER_88a8 },
  { name: '9100', value: ETHER_TYPE_LABEL.ETHER_9100 }
];

export const REBOOT_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];
